/*
 * @Author: 1544807500@qq.com
 * @Date: 2025-06-11 17:37
 * @LastEditors: yinping.che@ginlong.com
 * @LastEditTime: 2025-11-10 15:00
 * @FilePath: \glyun_web_vue3_master\src\router\maintenance.js
 * @Description: 运维路由
 */
export default [
  {
    path: '/maintenance',
    redirect: '/maintenance/alarm',
    name: 'maintenance',
    component: () => import('../views/nav/index.vue'),
    children: [
      {//报警
        path: 'alarm',
        name: 'maintenanceAlarm',
        component: () => import('../views/maintenance/alarm/index.vue'),
        meta: {
          title: 'v2_inverter_details_alarm_information',
          routeAuthCode: 'A0200',
        }
      },
      {//预警信息
        path: 'warning',
        redirect: '/maintenance/warning/deviceAbnormalOffline',
        name: 'maintenanceWarning',
        children: [
          {//设备异常离线
            path: 'deviceAbnormalOffline',
            name: 'maintenanceWarningDeviceAbnormalOffline',
            component: () => import('../views/maintenance/warning/deviceAbnormalOffline/index.vue'),
            meta: {
              title: 'v2_early_warning_device_abnormal_offline',
              routeAuthCode: 'A020404',
            }
          },
          {//低效发电电站
            path: 'inefficientPowerStation',
            name: 'maintenanceWarningInefficientPowerStation',
            component: () => import('../views/maintenance/warning/inefficientPowerStation/index.vue'),
            meta: {
              title: 'v2_early_warning_inefficient_power_plants',
              routeAuthCode:'A020405'
            }
          },
          {//低效发电电站
            path: 'stringPower',
            name: 'maintenanceWarningStringPower',
            component: () => import('../views/maintenance/warning/stringPower/index.vue'),
            meta: {
              title: 'v2_early_warning_string_abnormal_warning',
              routeAuthCode:'A020406'
            }
          },
        ],
      },
      {//IV曲线体检
        path: 'ivCurve',
        name: 'maintenanceIvCurve',
        component: () => import('../views/maintenance/ivCurve/index.vue'),
        meta: {
          title: 'v2_iv_curve_iv_curve_diagnosis',
          routeAuthCode: 'A0201'
        }
      },
      {//离散率分析
        path: 'discreteRateAnalysis',
        name: 'maintenanceDiscreteRateAnalysis',
        component: () => import('../views/maintenance/discreteRateAnalysis/index.vue'),
        meta: {
          title: 'v2_router_label26',
          routeAuthCode: 'A0203',
        }
      },
      {//集站分析
        path: 'deviceAnalysis',
        name: 'maintenanceDeviceAnalysis',
        component: () => import('../views/maintenance/deviceAnalysis/index.vue'),
        meta: {
          title: 'v2_fleet_analysis',
          routeAuthCode: 'A0205',
        }
      },
      {//设备控制
        path: 'deviceControl',
        name: 'maintenanceDeviceControl',
        component: () => import('../views/maintenance/deviceControl/index.vue'),
        meta: {
          title: 'v2_device_control',
          routeAuthCode: 'testCode',
        }
      },
      {//创建任务
        path: 'createTask',
        name: 'maintenanceDeviceControlCreateTask',
        component: () => import('../views/maintenance/deviceControl/components/createTask.vue'),
        meta: {
          title: 'v2_ota_create_tasks',
          routeAuthCode: 'testCode',
        }
      },
      {//任务详情
        path: 'deviceControlTaskDetail/:taskId',
        component: () => import('../views/maintenance/deviceControl/components/taskDetail.vue'),
        meta: {
          title: 'v2_ota_task_details',
          routeAuthCode: 'testCode',
        }
      },
    ],
  },
]
